import { render, staticRenderFns } from "./Avataaars.vue?vue&type=template&id=0f421abe&"
import script from "./Avataaars.vue?vue&type=script&lang=js&"
export * from "./Avataaars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports